import React, { useId } from "react";
import { Form } from "react-bootstrap";
import { parseRepeat } from "../../../model/millingStretch";

export default function MillingRepeatSettings({ value, onChange }) {
  const id = useId();
  return <fieldset className="border rounded p-2 my-2">
    <legend className="float-none w-auto fs-6">Minta ismétlése</legend>
    {[['repeatX', 'Vízszintes'], ['repeatY', 'Függőleges']].map(([key, label]) => {
      const enabled = !!value[key];
      const sectors=(value[key] || "").split(";");
      const update=(index,text)=>onChange({...value,[key]:sectors.map((s,i)=>i===index?text:s).join(";")});
      let error = "";
      try { parseRepeat(value[key]); } catch (failure) { error = failure.message; }
      return <div key={key} className="mb-2">
        <Form.Check id={`${id}-${key}`} label={`${label} ismétlés`} checked={enabled}
          onChange={e => onChange({ ...value, [key]: e.target.checked ? "40:60@20:80" : "" })} />
        {enabled && sectors.map((sector,index)=>{const [tile="",area=""]=sector.split("@");return <div key={index} className="d-flex gap-3 flex-wrap mt-2">
          <Form.Group><Form.Label>Másolandó mintaszakasz (%)</Form.Label>
            <Form.Control aria-label={`${label} ismétlés mintaszakasza (%)${index?` ${index+1}`:""}`} value={tile} placeholder="40:60" maxLength={100}
              onChange={e => update(index,`${e.target.value}@${area}`)} />
          </Form.Group>
          <Form.Group><Form.Label>Ismétléssel kitöltendő tartomány (%)</Form.Label>
            <Form.Control aria-label={`${label} ismétlés tartománya (%)${index?` ${index+1}`:""}`} value={area} placeholder="20:80" maxLength={100}
              onChange={e => update(index,`${tile}@${e.target.value}`)} />
          </Form.Group>
          <button type="button" className="btn btn-sm btn-outline-danger" onClick={()=>onChange({...value,[key]:sectors.filter((_,i)=>i!==index).join(";")})}>Szektor törlése</button>
        </div>;})}
        {enabled && <button type="button" className="btn btn-sm btn-outline-primary mt-2" disabled={sectors.length>=16} onClick={()=>onChange({...value,[key]:`${value[key]};@`})}>Új {label.toLowerCase()} szektor</button>}
        {error && <small role="alert" className="text-danger">{error}</small>}
      </div>;
    })}
    <small className="text-muted">Több szektornál a méretváltozás egyenlően oszlik el. Mindegyik szektor saját közepéből indul, a köztes részek változatlanok. Az intervallumok az eredeti kép/DXF százalékai: vízszintesen balról, függőlegesen alulról.
      Egy teljes minta a kitöltendő tartomány közepére kerül, a továbbiak kétoldalt ismétlődnek.
      A minta mérete nem változik; a két szélen azonos levágás lesz. A tartományon kívüli keret milliméterben megmarad.
      Az ismétlés az adott irányban a nyújtást váltja fel. Válassz egy teljes ismétlődő egységet, egymáshoz illő szélekkel.</small>
  </fieldset>;
}
